import { EditOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { ButtonProps } from 'antd/lib/button'
import * as React from 'react'

export const ButtonEditInline: React.FC<ButtonProps> = (props) => {
    return <Button type="link" icon={<EditOutlined />} size="small" {...props} />
}